import { gql } from '../../__generated__/gql'

export const STORE_SHOPPING_CART_QUERY = gql(`
  query storeShoppingCart {
    storeShoppingCart {
      ...shoppingCartFields
    }
  }
`)
